<script>
import {mapGetters} from 'vuex';
export default {
	data() {
		return {
			handlingNotification: false
		}

	},
	computed: {
		...mapGetters({
			unreadNotifications: 'notifications/unreadNotifications',
		}),
		storeNotification() {
			if(this.notificationId) {
				return this.unreadNotifications.find(x => x.id == this.notificationId);
			}
			return null;
		},
		notificationId() {
			return this.$route.query.ref == 'notification' && this.$route.query.notification_id;
		}
	},
	methods: {
		async handleNotification() {
			console.log("HANDLING NOTIFICATION")
			if(this.notificationId) {
				if(this.storeNotification) {
					if(!this.storeNotification.watched_ad) {
						await this.markAsRead();
					}
				}
				else {
					await this.markAsRead();
				}
			}
			return true;
		},
		async markAsRead() {
			console.log("MARKING AS READ NOTIFICATION...", this.notificationId)
			this.handlingNotification = true;
			await this.$store.dispatch('notifications/updateStatus', {
				action: 'watched',
				notification_ids: [this.notificationId]
			});
			this.$nextTick(() => {
				if(this.storeNotification) {
					this.$store.commit('notifications/decrementUnreadNotifications');
					this.$store.commit('notifications/incrementReadNotifications');
				}
			})

			this.handlingNotification = false;
		}
	}
}
</script>
